import Button from "components/Button";
import { Grid } from "components/Grid/Grid";
import Modal from "components/Modal";
import Text from "components/Text";
import "cropperjs/dist/cropper.css";
import { FC } from "react";
import {
    CoverImage,
    CoverImageUpload,
    CropImage,
    FileInput,
    ProfilePicture,
} from "./ImageUpload.styled";
import { useImageUpload } from "./useImageUpload";

export const ImageUpload: FC = () => {
    const {
        handleFileUpload,
        images,
        isModalOpen,
        toggleModal,
        imgSrc,
        cropperRef,
        isProfile,
        handleImageChange,
    } = useImageUpload();

    return (
        <>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <Modal.Header>Crop</Modal.Header>
                <Modal.Content>
                    <CropImage
                        isProfile={isProfile}
                        ref={cropperRef}
                        aspectRatio={isProfile ? 1 / 1 : 600 / 200}
                        src={imgSrc}
                        guides={false}
                        zoomOnWheel={false}
                        viewMode={2}
                        dragMode="crop"
                    />
                </Modal.Content>
                <Modal.Footer>
                    <Grid row={true} columnGap={1}>
                        <Button onClick={toggleModal} variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={handleFileUpload}>Submit</Button>
                    </Grid>
                </Modal.Footer>
            </Modal>
            <CoverImage url={images.cover?.url}>
                <CoverImageUpload htmlFor="coverPic">
                    <Text variant="body2" color="#fff">
                        Edit
                    </Text>
                    <FileInput
                        type="file"
                        id="coverPic"
                        accept="image/png, image/jpg, image/jpeg, image/HEIC"
                        onChange={handleImageChange}
                    />
                </CoverImageUpload>
                <ProfilePicture
                    url={images.profile?.url || "/images/user-placeholder.png"}
                    htmlFor="profilePic"
                >
                    <Text variant="body2" color="#fff">
                        Edit
                    </Text>
                    <FileInput
                        type="file"
                        id="profilePic"
                        accept="image/png, image/jpg, image/jpeg"
                        onChange={handleImageChange}
                    />
                </ProfilePicture>
            </CoverImage>
        </>
    );
};
